var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33317C14.1083 3.33317 14.4958 3.33317 14.8137 3.41836C15.6764 3.64952 16.3503 4.32339 16.5815 5.18612C16.6666 5.50404 16.6666 5.89153 16.6666 6.6665V14.3332C16.6666 15.7333 16.6666 16.4334 16.3942 16.9681C16.1545 17.4386 15.772 17.821 15.3016 18.0607C14.7668 18.3332 14.0668 18.3332 12.6666 18.3332H7.33331C5.93318 18.3332 5.23312 18.3332 4.69834 18.0607C4.22793 17.821 3.84548 17.4386 3.6058 16.9681C3.33331 16.4334 3.33331 15.7333 3.33331 14.3332V6.6665C3.33331 5.89153 3.33331 5.50404 3.4185 5.18612C3.64967 4.32339 4.32354 3.64952 5.18627 3.41836C5.50418 3.33317 5.89167 3.33317 6.66665 3.33317M7.49998 12.4998L9.16665 14.1665L12.9166 10.4165M7.99998 4.99984H12C12.4667 4.99984 12.7 4.99984 12.8783 4.90901C13.0351 4.82912 13.1626 4.70163 13.2425 4.54483C13.3333 4.36657 13.3333 4.13321 13.3333 3.6665V2.99984C13.3333 2.53313 13.3333 2.29977 13.2425 2.12151C13.1626 1.96471 13.0351 1.83723 12.8783 1.75733C12.7 1.6665 12.4667 1.6665 12 1.6665H7.99998C7.53327 1.6665 7.29991 1.6665 7.12165 1.75733C6.96485 1.83723 6.83737 1.96471 6.75747 2.12151C6.66665 2.29977 6.66665 2.53313 6.66665 2.99984V3.6665C6.66665 4.13321 6.66665 4.36657 6.75747 4.54483C6.83737 4.70163 6.96485 4.82912 7.12165 4.90901C7.29991 4.99984 7.53327 4.99984 7.99998 4.99984Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.7abb38e87d0280d1e9be51a76ba0b405.svg";
export { ForwardRef as ReactComponent };